type VoiceSurface = 'listen' | 'talk';

const closers = new Map<VoiceSurface, () => void>();
const stops = new Map<VoiceSurface, () => void>();
let owner: VoiceSurface | null = null;

function other(source: VoiceSurface): VoiceSurface {
  return source === 'listen' ? 'talk' : 'listen';
}

/** Registra o fecho desta cápsula. Não apaga o stop da outra ponta. */
export function bindVoiceClose(source: VoiceSurface, close: () => void): () => void {
  closers.set(source, close);
  return () => {
    if (closers.get(source) === close) closers.delete(source);
  };
}

/** Registra a parada da fala desta cápsula. */
export function bindVoiceStop(source: VoiceSurface, stop: () => void): () => void {
  stops.set(source, stop);
  return () => {
    if (stops.get(source) === stop) stops.delete(source);
  };
}

/** Abre esta cápsula e fecha a outra, parando a fala dela antes. */
export function activateVoiceSurface(source: VoiceSurface) {
  const previous = other(source);
  stops.get(previous)?.();
  closers.get(previous)?.();
  owner = source;
}

export function voiceSurfaceOwner(): VoiceSurface | null {
  return owner;
}
